import { render, staticRenderFns } from "./PsiDetailPayouts.vue?vue&type=template&id=67cb31e6"
import script from "./PsiDetailPayouts.vue?vue&type=script&lang=js"
export * from "./PsiDetailPayouts.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailPayouts.vue?vue&type=style&index=0&id=67cb31e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports